// import { useEffect } from "react";
// import { IClient } from "../../@types/system";
import * as Input from "../../components/Form/Input";
import { Button } from "../../components/Button";
import { Eye } from "lucide-react";
import { useLoading } from "../../store/useLoading";
import { useStore } from "../../store";
import { toast } from "react-toastify";
import api from "../../service/api";
import { useEffect, useState } from "react";
import { Loading } from "../../components/Loading";
import { EmptyList } from "../../components/EmptyList";
import { IUser } from "../../@types/system";
import {
  formatDate,
} from "../../utils/helpers";

export function ListUsers() {
  const loading = useLoading((store) => store.isLoading);
  const setLoading = useLoading((store) => store.setLoading);
  const users = useStore((store) => store.users);
  const user = useStore((store) => store.user);
  const setUsers = useStore((store) => store.setUsers);

  const [showClient, setShowClient] = useState(false);
  const [client, setClient] = useState({} as IUser);

  async function getData() {
    setLoading(true);
    try {
      const res = await api.get(`/users`);

      setUsers(res.data);
    } catch (error) {
      toast.error("Erro ao tentar carregar os dados, recarregue a página", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getData();
  }, []);

  function handleShowAction(user: IUser) {
    setShowClient(true);
    setClient(user);
  }
  function handleCancel() {
    setShowClient(false);
  }

  return (
    <>
      {loading && <Loading />}
      {!loading && users.length === 0 && <EmptyList />}
      {!loading && !showClient && users.length > 0 && (
        <ul
          role="list"
          className="divide-y divide-gray-100  dark:divide-zinc-800"
        >
          {users.map((person: any) => (
            <li key={person.cod} className="flex flex-col gap-3 py-5 sm:flex-row sm:justify-between sm:gap-x-6">
              <div className="flex min-w-0 gap-x-4">
                {/* <img className="h-12 w-12 flex-none rounded-full bg-gray-50" src={person.imageUrl} alt="" /> */}
                <div className="min-w-0 flex-auto">
                  <p className="text-sm font-semibold leading-6 text-gray-900  dark:text-white">
                    {person.nome +
                      " " +
                      person.login +
                      " - " +
                      person.is_admin === "1" ? "Admin" : "Usuário"}
                  </p>
                  {/* <p className="mt-1 truncate text-xs leading-5 text-gray-500 dark:text-zinc-400">
                    {person.email}
                  </p> */}
                </div>
              </div>
              <div className="shrink-0 sm:flex sm:items-center gap-x-1">
                <Button
                  type="button"
                  variant="outline"
                  onClick={() => handleShowAction(person)}
                >
                  <Eye className="h-4 w-4 text-zinc-400" strokeWidth={3} />
                </Button>
              </div>
            </li>
          ))}
        </ul>
      )}
      {showClient && (
        <>
          <form
            id="clients"
            className="mt-6 flex w-full flex-col gap-5 divide-y divide-zinc-200 dark:divide-zinc-800"
          >
            <div className="flex items-center justify-end gap-2 pt-5">
              <Button type="button" variant="outline" onClick={handleCancel}>
                Voltar
              </Button>
            </div>
            <div className="grid gap-3 pt-5 lg:grid-cols-form">
              <label
                htmlFor="document"
                className="text-sm font-medium text-zinc-700 dark:text-zinc-100"
              >
                Nome
              </label>
              <div className="flex gap-3">
                <Input.Root className={showClient ? "bg-zinc-100" : ""}>
                  <Input.Control
                    id="name"
                    type="text"
                    name="name"
                    placeholder="Nome"
                    value={`${user.name}`}
                    disabled={showClient}
                  />
                </Input.Root>
              </div>
            </div>

            <div className="grid gap-3 pt-5 lg:grid-cols-form">
              <label
                htmlFor="document"
                className="text-sm font-medium text-zinc-700 dark:text-zinc-100"
              >
                Data de cadastro
              </label>
              <div className="flex gap-3">
                <Input.Root className={showClient ? "bg-zinc-100" : ""}>
                  <Input.Control
                    id="created_at"
                    type="text"
                    name="created_at"
                    placeholder="Data de cadastro"
                    value={formatDate(client.created_at)}
                    disabled={showClient}
                  />
                </Input.Root>
              </div>
            </div>

            <div className="flex items-center justify-end gap-2 pt-5">
              <Button type="button" variant="outline" onClick={handleCancel}>
                Voltar
              </Button>
            </div>
          </form>
        </>
      )}
    </>
  );
}
